import uuid from "react-uuid";
import Loader from "../../../components/ui/Loader/Loader";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { Modal } from "bootstrap";
import { DisplayListPagination } from "../../../components/TapUi";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import TapIcon from "../../../services/TapIcon";
import { toast } from "react-toastify";
import swal from 'sweetalert';
import Status from "../../../components/ui/Status";

function AttachmentList() {

    const modalId           =   uuid();
    const modalElementRef   =   useRef();
    const modalRef          =   useRef();
    const attachmentUrl     =   IAM_API_BASE_URL_2 + '/attachment';
    const accessToken       =   useSelector(state => state.auth.access_token);
    
    const initialData       =   {
        name                    :   '',
        id                      :   '',
    };
    const [formData, setFormData]   =   useState({
        submittingForm  :   false,
        edit            :   false,
        submitData      :   initialData,
    });
    const [listData, setListData]   =   useState({
        loading     :   false,
        data        :   [],
        listingMeta :   null
    });

    useEffect(() => {
        listData.data.length === 0 && listDataApi();
        modalElementRef.current         =   document.getElementById(modalId);
        modalRef.current                =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const openModal                 =   (edit = false) => {
        setFormData(pre => ({...pre, edit}))
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        setFormData(pre => ({...pre, submitData: initialData}))
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }

    const listDataApi       =   (page = 1)  => {
        setListData(pre => ({...pre, loading : true}));
        HttpAPICall.withAthorization('GET', `${attachmentUrl}/list`, accessToken, {page}, {}, (resp) => {
            const respData      =   resp.data;   
            setListData(pr => ({
                ...pr, data : respData.data,
                listingMeta                 :   {
                    from                        :   respData.from,
                    to                          :   respData.to,
                    total                       :   respData.total,
                    last_page                   :   respData.last_page,
                    per_page                    :   respData.per_page,
                    current_page                :   respData.current_page
                }          
            }));  
        }).then(() => setListData(pr => ({...pr, loading : false})));

    }

    const submitForm                =   (e) => {
        e.preventDefault();
        setFormData(pre => ({...pre, submittingForm: true}));

        console.log(formData.submitData);

        const {submitData, edit} = formData
        const url = edit ? 'edit' : 'add' 
        const method = edit ? 'PUT' : 'POST'

        HttpAPICall.withAthorization(method, `${attachmentUrl}/${url}`, accessToken, {}, submitData, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            closeModal();
            listDataApi();
        }).then(() => setFormData(pre => ({...pre, submittingForm: false})));
    }

    const changeStatus             =    (id)  =>     {
        swal({
            title: "Change Status",
            text: "Are you sure you want to proceed?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willChangeStatus => {
            if (willChangeStatus) {
                HttpAPICall.withAthorization('PUT', `${attachmentUrl}/change_status/${id}`, accessToken, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    listDataApi();
                });
            }
        });
    }


    const handleEdit                =   (data) => {
        setFormData(pre => ({...pre, submitData: {name: data.name, id: data.id}}));
        openModal(true);
    } 

    const modalJsx                  =   () => {
        const {submittingForm, edit}          =   formData;
        console.log(edit);
        

        return <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{edit ? 'Edit' : 'Add'} Attachment Name</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={submittingForm} onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={submitForm} id={modalId+"Form"} method="post">
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label require">Name</label>
                                </div>
                                <div className="col-sm-6">
                                    <input
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFormData(pre => ({...pre, submitData: {...formData.submitData, name: e.target.value}}))
                                        }}
                                        value={formData.submitData.name}
                                        autoComplete="off"
                                        required={true}
                                        placeholder={`Please enter name`}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={submittingForm} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        <button type="submit" form={modalId+"Form"} disabled={submittingForm} className="btn btn-primary">Save {submittingForm && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    }


    return (
        <>
            <div className="tab_content_wrapper">
                <span className="content_heading">Attachments</span>
                <div className="text-end "><button className="btn btn-primary" onClick={() => openModal(false)}>Add</button></div>
            </div>
            <table className="table table-hover table-bordered my-2 table-sm ">
                <thead className="table-secondary">
                    <tr className="text-center">
                        <th scope="col" style={{ width: "6%" }}>#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Status</th>
                        <th scope="col" style={{ width: "15%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listData.loading 
                        ? <tr className="text-center"><td colSpan={4}><Loader/></td></tr>
                        : 
                        listData.data.length > 0 
                        ? listData.data.map((d, i) => (
                            <tr key={i}>
                                <td className="text-center">{listData.listingMeta ? listData.listingMeta.from + i : i}</td>
                                <td>{d.name}</td>
                                <td className="text-center">{d.status && <Status color={d.status.status_color_code}>{d.status.status_text}</Status>}</td>
                                <td className="text-center">
                                    <span className="dropdown">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn"><TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} /></button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><Link className="dropdown-item" role="button" onClick={() => handleEdit(d)}>Edit</Link></li>
                                        <li><Link className="dropdown-item" role="button" onClick={() => changeStatus(d.id)}>Change Status</Link></li>
                                    </ul>
                                    </span>
                                </td>
                            </tr>
                        ))
                        : <tr className="text-center"><td colSpan={4}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={listData.listingMeta} onPageChange={(e) => listDataApi(e.selected + 1)} />
            {modalJsx()}
        </>
    )
}

export default AttachmentList; 